require("./bootstrap");

window.Vue = require("vue").default;

import {
    DatePicker,
    Upload,
    Select,
    Option,
    Loading,
    Input,
    Notification,
    Checkbox,
    Pagination,
    Form,
    Autocomplete,
    Button,
    Table,
    TableColumn,
    Divider,
    Icon,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Switch,
    TimePicker,
    InputNumber,
} from "element-ui";

import VueSweetalert2 from "vue-sweetalert2";
import VDraggable from "vue-sortable-list";
import Toaster from "v-toaster";
import Sortable from "vue-drag-sortable";
import VueTimepicker from "vue2-timepicker";
import PortalVue from "portal-vue";
import Vue from "vue";
import { Datetime } from "vue-datetime";
import VueClipboard from 'vue-clipboard2'
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import "element-ui/lib/theme-chalk/index.css";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

import "sweetalert2/dist/sweetalert2.min.css";
import "v-toaster/dist/v-toaster.css";

require("./lib/index.js");
require("./components/backend/index.js");
require("./components/frontend/index.js");

Vue.use(VueSweetalert2);
Vue.use(Toaster);
Vue.use(VDraggable);
Vue.use(VueTimepicker);
Vue.use(Datetime);
Vue.use(PortalVue);

Vue.use(DatePicker);
Vue.use(TimePicker)
Vue.use(Upload);
Vue.use(Select);
Vue.use(Option);
Vue.use(Loading);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Checkbox);
Vue.use(Pagination);
Vue.use(Form);
Vue.use(Autocomplete);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Divider);
Vue.use(Icon);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

Vue.use(Switch);
Vue.prototype.$notify = Notification;
locale.use(lang);

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

Vue.component("sortable", Sortable);
Vue.component("datetime", Datetime);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: "#app"
});
